const getBasename = (filename: string): string => /^(.+)\..*$/.exec(filename)?.[1] ?? filename;

export function generateLinuxScript(filenames: string[], clientName: string, sessionName: string): string {
    const list = filenames.map(getBasename).join('\n');

    return `#!/bin/sh

scriptdir=$(CDPATH= cd -- "$(dirname -- "$0")" && pwd)
copy_to="$scriptdir/skopiowane_zdjecia"

cat <<'BANNER'

@@@@@@@@@@@@@             @@@@@       @@@@@@      @@@@@@   @@@@@@@@@@@
@@@@@@@@@@@@    (@@@@@@   @@@@@@     @@@@@@@      @@@@@  @@@@@@@@@@@@
@@@@@*            *@@@@@@  @@@@@*    @@@@@@@@    @@@@@   @@@@@@
@@@@@      @@@@@@@@@@@@@@@  @@@@@   @@@@@@@@@@  @@@@@     @@@@@@@@@@.
@@@@@    @@@@@@@@@@@@@@@@@   @@@@@ @@@@@@@@@@@  @@@@@        @@@@@@@@@@@
@@@@@    @@@@@      @@@@@@    @@@@@@@@@@  @@@@@@@@@@               @@@@@@
@@@@@   .@@@@@       @@@@@    @@@@@@@@@   @@@@@@@@@        %@@      @@@@@&
@@@@@   .@@@@@       @@@@@     @@@@@@@,    @@@@@@@       @@@@@@@@@@@@@@@@
@@@@@    @@@@@@@     @@@@@      @@@@@@      @@@@@          @@@@@@@@@@@@
            @@@@@@@@@@@@@@@@
                @@@@@@         Twoja sesja pod kontrola

####################################################################
Wyszukiwarka plikow zamowienia "${clientName}" z sesji "${sessionName}"
####################################################################
BANNER

echo "Wpisz rozszerzenie plikow, ktorych szukamy, np: jpg, cr2, png itp."
printf "Jakich plikow szukac?: "
IFS= read -r ext
[ -z "$ext" ] && ext="jpg"
ext=\${ext#.}

echo "Szukam .$ext i kopiuję do $copy_to"
mkdir -p "$copy_to"
copied=0
missing=0

while IFS= read -r photo; do
    [ -z "$photo" ] && continue
    matches_file=$(mktemp)
    find "$scriptdir" -type f -iname "$photo.$ext" > "$matches_file"

    if [ ! -s "$matches_file" ]; then
        printf "Nie znaleziono: %s.%s\\n" "$photo" "$ext"
        missing=$((missing + 1))
    else
        while IFS= read -r src; do
            [ -z "$src" ] && continue
            cp -f "$src" "$copy_to/"
            copied=$((copied + 1))
            printf "Kopiuję %s\\n" "$src"
        done < "$matches_file"
    fi

    rm -f "$matches_file"
done <<'PHOTO_LIST'
${list}
PHOTO_LIST

echo ""
if [ "$copied" -eq 0 ]; then
    echo "Nie znaleziono żadnych pasujących plików w folderze skryptu i podfolderach."
else
    echo "Skopiowano $copied plikow do: $copy_to"
fi
echo "Brakujących pozycji: $missing"`;
}
